// extracted by mini-css-extract-plugin
export default {"container":"CustomerSectionWrapper_container__MxUrD","title":"CustomerSectionWrapper_title__Fic4Z","sectionName":"CustomerSectionWrapper_sectionName__b9kBX"};